// The highlighter pen from the Figma menu design (Streamline "Design-Tool-Glue").
// When a highlight color is active, the pen sits on a rounded box of that color.
export default function IconHighlight({
  className,
  style,
  /** Fill of the box behind the pen — the active highlight color (none when unset). */
  boxColor,
}: {
  className?: string
  style?: React.CSSProperties
  boxColor?: string
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 30.0007 31.8821"
      fill="none"
      className={className}
      style={style}
    >
      {boxColor && <rect x="1" y="1.9" width="28" height="28" rx="5" fill={boxColor} />}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.8237 2.04866C16.4192 2.16116 16.3965 2.18216 12.9817 5.59866C11.1508 7.43046 9.5766 9.03186 9.4835 9.15726C9.1183 9.64906 8.9075 10.0798 8.746 10.6641C8.6266 11.0961 8.5806 11.9177 8.6506 12.3665L8.6948 12.6497L4.7837 16.5655C2.2483 19.1039 0.8394 20.5415 0.7782 20.6523C0.596 20.9826 0.5939 21.0165 0.6056 23.5213L0.6167 25.8773L0.7353 26.1243C0.8862 26.4389 1.1571 26.7098 1.4717 26.8607L1.7187 26.9793H8.2737H14.8287L15.0757 26.868C15.3031 26.7656 15.4722 26.6083 17.2037 24.8889L19.0847 23.0211L19.2747 23.055C19.5587 23.1057 20.4185 23.1019 20.698 23.0488C21.3159 22.9313 21.9343 22.6683 22.4447 22.3059C22.6426 22.1653 23.7912 21.0403 26.1183 18.7073C29.9791 14.837 29.6867 15.1822 29.6867 14.4955C29.6867 14.1215 29.6788 14.0796 29.5635 13.8455C29.272 13.2532 28.6542 12.9304 27.9859 13.0212C27.4856 13.0891 27.6196 12.9696 23.9867 16.5878C20.2917 20.2679 20.5021 20.0831 20.0025 20.087C19.6986 20.0893 19.5043 20.0367 19.2915 19.8945C19.1986 19.8326 17.4792 18.1352 15.4705 16.1226C12.5424 13.1889 11.8002 12.4256 11.7275 12.2733C11.6538 12.1191 11.6367 12.0225 11.6367 11.7603C11.6367 11.1586 11.4091 11.4229 15.1872 7.63726C18.396 4.42206 18.5278 4.28456 18.6072 4.06776C18.8342 3.44836 18.6968 2.83386 18.2344 2.40136C18.1339 2.30736 17.9934 2.20026 17.9222 2.16336C17.6068 2.00026 17.164 1.95396 16.8237 2.04866ZM6.9722 18.6288L3.5997 22.0015V22.9989V23.9963H8.7204H13.8411L15.1518 22.6852L16.4625 21.3741L13.4035 18.3152L10.3446 15.2563L6.9722 18.6288Z"
        fill="currentColor"
      />
    </svg>
  )
}
